import http from "../../http-common";

const getChunks = async(corridor, date) => {
    const response = await http.get(`/chunks/${corridor}/${date}`).then((response) => {
        return response
    })
    console.log(`chunks found: ${response.data.chunks}`)
    let chunkList = await response.data.chunks
    return chunkList
}


export default getChunks;
